import formComponent from '@/util/proto/formComponent'

export default {
  extends: formComponent ,
  components:{ },
  data() {
    return {
      formData: {
        name: {
          rules:[
            { required: true, message: '请输入设备名称', trigger: 'blur,change' },
          ]
        },
        brand: {
          rules:[
            { required: true, message: '请选择设备厂商', trigger: 'blur,change' },
          ]
        },
        spec: {
          rules:[
            { required: true, message: '请选择设备型号', trigger: 'blur,change' },
          ]
        },
        deviceSn: {
          rules:[
            { required: true, message: '请输入设备序列号', trigger: 'blur,change' },
          ]
        },
        carNo:null
        
      },
     
      id:null,
      loading:false,
      visible:false,
      api:['rfidDeviceCreate','rfidDeviceUpdate'],
    }
  },

  computed:{
    title(){
      return this.id ? '修改设备' : '新增设备'
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      if (this.id) {
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.rfidDevice(this.id).then(resp => {
        this.$setFormData(resp.data)
        this.loading = false
      })
    },
    beforeSave(d){
      let params = { ...d }
      if(this.id){
        params.id = this.id
      }

      return params
    },
  },

  render(){
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title}>
        <sl-form label-width={100}>
          <sl-form-item label="设备名称">
            <Input v-decorator={this.formData.name} placeholder="请输入设备名称" />
          </sl-form-item>
          <sl-form-item label="设备厂商">
            <sl-select placeholder="请选择设备厂商" v-decorator={this.formData.brand} dict="$$device_brand" value-type="string" />
          </sl-form-item>
          <sl-form-item label="设备型号">
            <sl-select placeholder="请选择设备型号" v-decorator={this.formData.spec} dict="$$device_spec" value-type="string" />
          </sl-form-item>
          <sl-form-item label="设备序列号">
            <Input v-decorator={this.formData.deviceSn} placeholder="请输入设备序列号" />
          </sl-form-item>
          <sl-form-item label="车辆编号">
            <Input v-decorator={this.formData.carNo} placeholder="请输入车辆编号" />
          </sl-form-item>
        </sl-form>
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}